import React from 'react';
import styled from 'styled-components';
import {Icon} from '../../Icon/Icon';
import {TableHeader} from '../table-sections/TableHeader';

const SortableTH = styled(TableHeader)`
    cursor: pointer;
    &:hover {
        color: var(--blue-07);
    }
`;

export const SortableTableHeader = ({children, isCurrentSort, currentDirection, ...props}) => (
    <SortableTH isCurrentSort={isCurrentSort} {...props}>
        {children}
        {isCurrentSort && (
            <>
                {currentDirection && <Icon type="md" name="ExpandLess" />}
                {!currentDirection && <Icon type="md" name="ExpandMore" />}
            </>
        )}
    </SortableTH>
);
